import debugUtil from '../util/debug';
import Sizzle from 'sizzle';

const Debug = debugUtil('linkpulse');
const NAMESPACE = 'linkpulse';
const instances = new Map();

const getVideoElement = (api) => Sizzle('video', api.element())[0];

class LinkpulsePlugin {
    constructor(api) {
        this.api = api;
        this.lpvideo = new LP4.video.logger(); // eslint-disable-line new-cap
        this.hasEndedSinceLastPlaying = false;

        this.setupListeners();
    }

    setupListeners() {
        this.api.on(`${NAMESPACE}.metadata`, ({ detail }) => {
            const id = 'https://api.svt.se/video/' + detail.programVersionId;
            Debug.log('setVideoUrl()', id);
            this.lpvideo.setVideoUrl(id);

            let posterUrl = getVideoElement(this.api).getAttribute('poster');
            Debug.log('setVideoImg()', posterUrl);
            this.lpvideo.setVideoImg(posterUrl);

            const videoTitle = `${detail.mmsStatistics.ns_st_pr} - ${detail.mmsStatistics.ns_st_ep} (${detail.programVersionId})`;
            Debug.log('setVideoTitle()', videoTitle);
            this.lpvideo.setVideoTitle(videoTitle);
        });


        this.api.on(`${NAMESPACE}.loadeddata`, () => {
            Debug.log('logLoadstart()');
            this.lpvideo.logLoadstart();
        });

        this.api.on(`${NAMESPACE}.playing`, () => {
            const duration = this.api.getDuration();
            Debug.log('setDuration()', duration);
            this.lpvideo.setDuration(duration);

            Debug.log('setPaused()', false);
            this.lpvideo.setPaused(false);

            const currentTime = this.api.getCurrentTime();
            const isReplay = this.hasEndedSinceLastPlaying;

            Debug.log('logPlaystart()', currentTime, isReplay);
            this.lpvideo.logPlaystart(currentTime, isReplay);

            this.hasEndedSinceLastPlaying = false;
        });

        this.api.on(`${NAMESPACE}.pause`, () => {
            Debug.log('setPaused()', true);
            this.lpvideo.setPaused(true);
        });

        this.api.on(`${NAMESPACE}.timeupdate`, () => {
            if (!this.lpvideo.getLoggedPlaystart()) {
                return;
            }

            const currentTime = this.api.getCurrentTime();

            Debug.log('logTimeupdate()', currentTime);
            this.lpvideo.logTimeupdate(currentTime);
        });

        this.api.on(`${NAMESPACE}.ended`, () => {
            const currentTime = this.api.getCurrentTime();

            Debug.log('logEnded()', currentTime);
            this.lpvideo.logEnded(currentTime);
            this.hasEndedSinceLastPlaying = true;
        });
    }

    destroy() {
        this.api.off(`${NAMESPACE}.metadata`);
        this.api.off(`${NAMESPACE}.ready`);
        this.api.off(`${NAMESPACE}.playing`);
        this.api.off(`${NAMESPACE}.pause`);
        this.api.off(`${NAMESPACE}.timeupdate`);
        this.api.off(`${NAMESPACE}.ended`);

        this.lpvideo.setPaused(true);

        this.lpvideo = null;
    }
}

export function create(api) {
    if (instances.has(api)) {
        Debug.warn(
            `Linkpulse plugin was already created for this api instance and has
            not been destroyed. The previous instance may leak memory and listeners.`
        );
    }

    const hasLinkpulse = () => (window.LP4 && window.LP4.video);
    const hasConfiguredLinkpulseVideoLogger = () => (
        window.LP4.config &&
        window.LP4.config.video &&
        window.LP4.config.video.length >= 0
    );

    if (hasLinkpulse() && !hasConfiguredLinkpulseVideoLogger()) {
        Debug.log('Creating LinkpulsePlugin');
        instances.set(api, new LinkpulsePlugin(api));
    }
}

export function destroy(api) {
    const instance = instances.get(api);
    if (instance) {
        instance.destroy();
        instances.delete(api);
    }
}




// WEBPACK FOOTER //
// ./src/js/plugins/linkpulse.js